<ion-app [ngClass]="theme + ' ' + mode">
  <ion-router-outlet [ngClass]="platforms"></ion-router-outlet>
</ion-app>
